export default {
  ROUTE_COMPANY_ACCOUNT: '/company-account',
};
